import { createServiceToken } from "@nasam/kernel";

import type { AlertHistoryRepository } from "../features/alerts/domain";

// Alert History lives beside the other shared contracts, not only in the
// alerts feature, so another module (Tracking's per-vehicle Alerts tab) can
// read it without importing across the alerts module boundary.
export type {
  AlertEvidence,
  AlertHistoryDetail,
  AlertHistoryDetails,
  AlertHistoryItem,
  AlertHistoryLocation,
  AlertHistoryQuery,
  AlertHistoryRepository,
} from "../features/alerts/domain";
export { ALERT_EVIDENCE_VIEW, ALERT_HISTORY_VIEW } from "../features/alerts/alertsPermissions";

export const alertHistoryRepositoryToken = createServiceToken<AlertHistoryRepository>(
  "alerts.history-repository",
);
